import ReactPlayer from 'react-player';
import { BaseReactPlayerProps, SourceProps } from 'react-player/base';

type VideoPlayerProps = {
  url: string | string[] | SourceProps[] | MediaStream | undefined;
  playing?: boolean;
  thumbnailUrl?: string;
  playIcon?: BaseReactPlayerProps['playIcon'];
};

export const VideoPlayer = (props: VideoPlayerProps) => {
  const { url, playing = false, thumbnailUrl, playIcon } = props;
  return (
    <div className="player-wrapper">
      <ReactPlayer
        url={url}
        className="react-player"
        playing={playing}
        controls
        light={
          thumbnailUrl ? (
            <img src={thumbnailUrl} width={'100%'} height={'100%'} />
          ) : undefined
        }
        playIcon={playIcon}
        muted={true}
        width="100%"
        height="100%"
      />
    </div>
  );
};
